// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"NotificationToast_notificationContainer__2HW0A","notification":"NotificationToast_notification__1LhBm","slide-in":"NotificationToast_slide-in__1Cvx8"};